import { Paper, Typography } from "@mui/material";

const NoRecordFound = ({ message }) => {
  return (
    <>
      <Paper className="no-record-found" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "#e5e9f5 !important", height: "30px" }}> <Typography variant='p' sx={{ fontSize: '13px' }}>{message || 'No Record Found'}</Typography> </Paper>
    </>
  );
};

export default NoRecordFound;
